import React, { useState } from 'react';

import { Dropdown, EarningsPerShow } from '@trqk/components';
import { locale } from '@trqk/utils';

/**
 * @typedef {EarningsBreakdownProps}
 * @property {string} id a unique ID for the EarningsPerShow chart instance
 * @property {number} height chart height
 * @property {ProShow[]} shows array of ProShow objects
 * @property {boolean} truncateChartData whether to summarize small values into a single show
 */
interface EarningsBreakdownProps {
    id: string;
    height: number;
    shows: ProShow[];
    truncateChartData: boolean;
}

const dropdownOptions: DropdownOption<EarningsBreakdownChartType>[] = [
    {
        value: 'earningsBreakdownByProgram' as EarningsBreakdownByProgram,
        label: locale.enUS.STATEMENTS.SECTIONS.BREAKDOWN.FILTER_BY_PROGRAM,
    },
    // {
    //     value: 'earningsBreakdownByMedia' as EarningsBreakdownByMedia,
    //     label: locale.enUS.STATEMENTS.SECTIONS.BREAKDOWN.FILTER_BY_MEDIA,
    // },
];

const defaultOptionIndex = 0;

export const EarningsBreakdown = ({
    id,
    height,
    shows,
    truncateChartData,
}: EarningsBreakdownProps): JSX.Element => {
    const setChartType = useState(dropdownOptions[defaultOptionIndex].value)[1];

    return (
        <div className="bg-white rounded-lg">
            <div className="p-6">
                <div className="flex justify-start items-center">
                    <h4 className="mr-2">
                        {
                            locale.enUS.STATEMENTS.SECTIONS.BREAKDOWN
                                .CONTENT_TITLE
                        }
                    </h4>
                    <Dropdown
                        defaultIndex={defaultOptionIndex}
                        options={dropdownOptions}
                        handleChange={(
                            value: EarningsBreakdownChartType,
                        ): void => {
                            setChartType(value);
                        }}
                    />
                </div>
                <EarningsPerShow
                    chartDivId={`${id}.earnings-per-show`}
                    shows={shows}
                    height={height}
                    truncateChartData={truncateChartData}
                />
            </div>
        </div>
    );
};
